import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './EmailInfo.css';

class EmailInfo extends React.Component {
  constructor(props) {
    super(props);
    this.handleEditEmail = this.handleEditEmail.bind(this);
    this.state = {
      email: props.email,
    };
  }

  /**
   * Handles clicks to the 'edit' button...
   */
  handleEditEmail(event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    event.preventDefault();
    this.props.onEdit();
    return false;
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <p>Email address on file:</p>
        <div className={styles.savedEmail}>
          <p>{this.state.email}</p>
          <a href="/" onClick={this.handleEditEmail}>
            Edit
          </a>
        </div>
      </div>
    );
  }
}

EmailInfo.propTypes = {
  email: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default EmailInfo;



// WEBPACK FOOTER //
// ./src/containers/CartPage/EmailInfo.jsx